import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class Bell extends Component {
  static propTypes = {
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        width={width}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill={strokeColor}
          d="M20.45,17.33a15.21,15.21,0,0,1-1.69-6.79c0-4.27-1-8.53-7.26-8.53S4.24,6.27,4.24,10.53a15.21,15.21,0,0,1-1.69,6.79A.47.47,0,0,0,3,18H8.5a3,3,0,0,0,6,0H20A.47.47,0,0,0,20.45,17.33ZM11.5,20a2,2,0,0,1-2-2h4A2,2,0,0,1,11.5,20Zm2.82-3H3.82a16,16,0,0,0,1.43-6.47C5.24,5.18,7.06,3,11.5,3s6.26,2.18,6.26,7.53A16,16,0,0,0,19.18,17Z"
        />
      </SVGElement>
    );
  }
}
